import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { PreliminaryEtrLearnMoreLink } from "../PreliminaryEtrLearnMoreLink/PreliminaryEtrLearnMoreLink";
import { ReactComponent as IconInformation } from "../../assets/icons/icon-information.svg";
import { COMPLEX, MAJOR, MINOR, MODERATE } from "../PreliminaryEtrType";

export const InlineMessageContainer = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-template-areas:
    "icon content"
    "icon link";
  column-gap: 12px;
  background-color: ${p => p.theme.colors.blue};
  color: ${p => p.theme.colors.blueGray};
  border-radius: 12px;
  padding: 12px 16px;
`;

const IconInformationContainer = styled(IconInformation)`
  grid-area: icon;
  width: 20px;
  height: 20px;
  display: block;
`;

export const InlineMessageContentContainer = styled.div`
  grid-area: content;
  font-size: ${props => props.theme.fontSizes[1]}px;
  line-height: 1.5;
`;

export const PreliminaryEtrLearnMoreLinkContainer = styled.div`
  grid-area: link;
`;

export const InlineMessage = ({
  showOutageCategoryMessage,
  content,
  preliminaryEtrType,
}) =>
  showOutageCategoryMessage ? (
    <InlineMessageContainer role="dialog">
      <IconInformationContainer />
      <InlineMessageContentContainer>{content}</InlineMessageContentContainer>
      <PreliminaryEtrLearnMoreLinkContainer>
        <PreliminaryEtrLearnMoreLink preliminaryEtrType={preliminaryEtrType} />
      </PreliminaryEtrLearnMoreLinkContainer>
    </InlineMessageContainer>
  ) : null;

InlineMessage.propTypes = {
  showOutageCategoryMessage: PropTypes.bool,
  content: PropTypes.node.isRequired,
  preliminaryEtrType: PropTypes.oneOf([MINOR, MODERATE, MAJOR, COMPLEX]),
};

InlineMessage.defaultProps = {
  showOutageCategoryMessage: false,
  preliminaryEtrType: MINOR,
};
